var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { Row, Col, Button, MessageBanner } from "@folio/stripes/components";
import { useQuery, useMutation } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { Controller, useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { debounce } from "lodash";
import { RecekSelect, RecekSelection, RecekTextField } from "./inputs";
import { fetchCollectionByIssn } from "../api/collectionsService";
import { fetchAgencyPublisherBySourceId, searchAgencyPublishers, } from "../api/publisherService";
import { CollectionMediumEnum, CollectionStatusEnum, CollectionTypeEnum, } from "../types/Api";
import { normalizeIssn } from "../utils/collectionDisplayUtils";
import { formatPublisherLabel } from "../utils/formatPublisherLabel";
import { fetchCurrentUser } from "../api/userService";
import { locksCollectionPublisherToOwn } from "../utils/permissionsUtils";
import css from "./CollectionFields.module.css";
// DB-787: outcome of the ISSN lookup (ISSN register first, then a title carrying the ISSN)
var ISSN_LOOKUP_BANNER = {
    registered: {
        type: "success",
        messageId: "ui-br-agency.collections.issnRegister.loaded",
    },
    notRegistered: {
        type: "warning",
        messageId: "ui-br-agency.collections.issnRegister.notFound",
    },
    error: {
        type: "error",
        messageId: "ui-br-agency.collections.issnRegister.error",
    },
};
export var CollectionGeneralFields = function (_a) {
    var _b;
    var initialValues = _a.initialValues;
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _c = useFormContext(), control = _c.control, setValue = _c.setValue, getValues = _c.getValues, watch = _c.watch, errors = _c.formState.errors;
    var selectedType = watch("type");
    var _d = useState(false), isPublisherLocked = _d[0], setIsPublisherLocked = _d[1];
    var _e = useState(""), publisherQuery = _e[0], setPublisherQuery = _e[1];
    var _f = useState(null), fetchedOrgId = _f[0], setFetchedOrgId = _f[1];
    var _g = useState(false), hasAttemptedFetch = _g[0], setHasAttemptedFetch = _g[1];
    var _h = useState(null), issnLookupResult = _h[0], setIssnLookupResult = _h[1];
    useEffect(function () {
        var _a;
        if (((_a = initialValues === null || initialValues === void 0 ? void 0 : initialValues.publisher) === null || _a === void 0 ? void 0 : _a.name) &&
            !publisherQuery &&
            !isPublisherLocked) {
            setPublisherQuery(initialValues.publisher.name);
        }
    }, [initialValues === null || initialValues === void 0 ? void 0 : initialValues.publisher, publisherQuery, isPublisherLocked]);
    var _j = useQuery(["currentUser"], function () { return fetchCurrentUser(ky); }, { staleTime: Infinity }), currentUser = _j.data, isCurrentUserLoading = _j.isLoading;
    var _k = useQuery(["publishers", publisherQuery], function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!publisherQuery.trim() || isPublisherLocked) {
                return [2 /*return*/, { items: [] }];
            }
            return [2 /*return*/, searchAgencyPublishers(ky, {
                    query: "name=\"".concat(publisherQuery.trim(), "*\" or name=\"*").concat(publisherQuery.trim(), "*\""),
                    limit: 20,
                })];
        });
    }); }, {
        enabled: !!publisherQuery.trim() && !isPublisherLocked,
        staleTime: 30000,
        select: function (data) { var _a; return (_a = data.items) !== null && _a !== void 0 ? _a : []; },
    }), _l = _k.data, publishers = _l === void 0 ? [] : _l, publisherLoading = _k.isLoading;
    var issnLookupMutation = useMutation(function (issn) { return fetchCollectionByIssn(ky, issn); }, {
        onSuccess: function (data) {
            var _a, _b;
            if (data === null || data === void 0 ? void 0 : data.issnRegistered) {
                // DB-787: the ISSN register is the master of these fields
                var options = { shouldValidate: true, shouldDirty: true };
                if (data.issn)
                    setValue("issn", data.issn, options);
                if (data.mainName)
                    setValue("mainName", data.mainName, options);
                // edition record -> PUBLISHER_SERIES, yearbook -> SERIES; a type already chosen is kept
                if (data.type && !getValues("type"))
                    setValue("type", data.type, options);
                setValue("qualifier", (_a = data.qualifier) !== null && _a !== void 0 ? _a : "", options);
                setValue("status", (_b = data.status) !== null && _b !== void 0 ? _b : CollectionStatusEnum.UNKNOWN, options);
                setValue("endYear", data.endYear, options);
                setValue("medium", data.medium, options);
                setIssnLookupResult("registered");
                return;
            }
            if (data === null || data === void 0 ? void 0 : data.mainName) {
                setValue("mainName", data.mainName, { shouldValidate: true });
            }
            setIssnLookupResult("notRegistered");
        },
        onError: function (error) {
            setIssnLookupResult("error");
            console.error("ISSN lookup failed", error);
        },
    });
    useEffect(function () {
        var _a, _b, _c, _d;
        if (isCurrentUserLoading || !currentUser)
            return;
        var roles = (_a = currentUser.activeRoles) !== null && _a !== void 0 ? _a : [];
        var shouldLockPublisher = locksCollectionPublisherToOwn(roles);
        if (shouldLockPublisher) {
            setIsPublisherLocked(true);
            if (initialValues === null || initialValues === void 0 ? void 0 : initialValues.publisher)
                return;
            var org = (_b = currentUser.activeOrganization) !== null && _b !== void 0 ? _b : (_c = currentUser.userOrganizations) === null || _c === void 0 ? void 0 : _c[0];
            if (!org)
                return;
            var orgId = (_d = org.sourceId) !== null && _d !== void 0 ? _d : org.id;
            var orgName = org.name;
            if (!orgId || !orgName)
                return;
            if (fetchedOrgId === orgId)
                return;
            setFetchedOrgId(orgId);
        }
    }, [
        isCurrentUserLoading,
        currentUser,
        setValue,
        fetchedOrgId,
        initialValues === null || initialValues === void 0 ? void 0 : initialValues.publisher,
    ]);
    var orgPublisherMutation = useMutation(function (orgSourceId) { return fetchAgencyPublisherBySourceId(ky, orgSourceId); }, {
        onSuccess: function (publisher) {
            setValue("publisher", publisher, { shouldValidate: true });
            setIsPublisherLocked(true);
            setHasAttemptedFetch(true);
        },
        onError: function () {
            setIsPublisherLocked(false);
            setHasAttemptedFetch(true);
        },
    });
    useEffect(function () {
        if (fetchedOrgId && !hasAttemptedFetch && !(initialValues === null || initialValues === void 0 ? void 0 : initialValues.publisher)) {
            orgPublisherMutation.mutate(fetchedOrgId);
        }
    }, [fetchedOrgId, hasAttemptedFetch, initialValues === null || initialValues === void 0 ? void 0 : initialValues.publisher]);
    var handleIssnBlur = function () { return __awaiter(void 0, void 0, void 0, function () {
        var issn, normalized;
        var _a;
        return __generator(this, function (_b) {
            issn = (_a = getValues("issn")) === null || _a === void 0 ? void 0 : _a.trim();
            if (!issn)
                return [2 /*return*/];
            normalized = normalizeIssn(issn);
            if (normalized !== issn) {
                setValue("issn", normalized, { shouldDirty: true });
            }
            issnLookupMutation.mutate(normalized);
            return [2 /*return*/];
        });
    }); };
    var debouncedSetPublisherQuery = React.useMemo(function () { return debounce(function (val) { return setPublisherQuery(val); }, 300); }, []);
    var handlePublisherInput = function (inputValue) {
        if (isPublisherLocked)
            return;
        if (inputValue === publisherQuery)
            return;
        debouncedSetPublisherQuery(inputValue);
    };
    var handlePublisherSelection = function (selectedPublisherId) {
        var selectedPublisher = publishers.find(function (publisher) { return publisher.id === selectedPublisherId; });
        if (selectedPublisher) {
            setValue("publisher", selectedPublisher, {
                shouldValidate: true,
            });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(Controller, { control: control, name: "type", render: function (_a) {
                        var _b;
                        var field = _a.field;
                        return (React.createElement(RecekSelect, __assign({ labelId: "ui-br-agency.collections.general.type.select.label" }, field, { value: field.value || "", required: true, placeholder: formatMessage({
                                id: "ui-br-agency.collections.general.type.select.placeholder",
                            }), error: (_b = errors.type) === null || _b === void 0 ? void 0 : _b.message }),
                            React.createElement("option", { value: CollectionTypeEnum.PUBLISHER_SERIES }, formatMessage({
                                id: "ui-br-agency.collections.type.publisherSeries",
                            })),
                            React.createElement("option", { value: CollectionTypeEnum.SERIES }, formatMessage({
                                id: "ui-br-agency.collections.type.series",
                            }))));
                    } })),
            React.createElement(Col, { xs: 6 },
                React.createElement(Controller, { control: control, name: "publisher", render: function (_a) {
                        var _b, _c, _d;
                        var field = _a.field;
                        return (React.createElement(RecekSelection, { labelId: "ui-br-agency.collections.general.publisher.selection.label", asyncFilter: true, placeholder: formatMessage({
                                id: "ui-br-agency.collections.general.publisher.selection.placeholder",
                            }), value: (_c = (_b = field.value) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : "", error: (_d = errors.publisher) === null || _d === void 0 ? void 0 : _d.message, disabled: publisherLoading || isPublisherLocked, loading: publisherLoading, required: selectedType === CollectionTypeEnum.PUBLISHER_SERIES, onFilter: handlePublisherInput, onChange: handlePublisherSelection, dataOptions: (function () {
                                var publisherOptions = [];
                                if (field.value) {
                                    var currentPublisher = field.value;
                                    publisherOptions.push({
                                        value: currentPublisher.id,
                                        label: formatPublisherLabel(currentPublisher, formatMessage),
                                    });
                                }
                                if (Array.isArray(publishers)) {
                                    publishers.forEach(function (publisher) {
                                        if (!publisherOptions.find(function (existingOption) {
                                            return existingOption.value === publisher.id;
                                        })) {
                                            publisherOptions.push({
                                                value: publisher.id,
                                                label: formatPublisherLabel(publisher, formatMessage),
                                            });
                                        }
                                    });
                                }
                                return publisherOptions;
                            })() }));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "issn", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.collections.general.issn.field.label" })));
                    } })),
            React.createElement(Col, { xs: 2, className: css.fieldButtonCol },
                React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, onClick: handleIssnBlur, disabled: issnLookupMutation.isLoading || !((_b = watch("issn")) === null || _b === void 0 ? void 0 : _b.trim()) },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.collections.button.load" }))),
            React.createElement(Col, { xs: 6 },
                React.createElement(Controller, { control: control, name: "mainName", render: function (_a) {
                        var _b;
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.collections.general.mainName.field.label", required: true, error: (_b = errors.mainName) === null || _b === void 0 ? void 0 : _b.message })));
                    } }))),
        issnLookupResult && (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(MessageBanner, { type: ISSN_LOOKUP_BANNER[issnLookupResult].type, dismissible: true, onExited: function () { return setIssnLookupResult(null); } },
                    React.createElement(FormattedMessage, { id: ISSN_LOOKUP_BANNER[issnLookupResult].messageId, 
                        // DB-787: "written to the series / edition again" follows the collection type
                        values: { type: selectedType !== null && selectedType !== void 0 ? selectedType : "other" } }))))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(Controller, { control: control, name: "qualifier", render: function (_a) {
                        var _b;
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { value: (_b = field.value) !== null && _b !== void 0 ? _b : "", labelId: "ui-br-agency.collections.general.qualifier.field.label", placeholder: formatMessage({
                                id: "ui-br-agency.collections.general.qualifier.field.placeholder",
                            }) })));
                    } })),
            React.createElement(Col, { xs: 2 },
                React.createElement(Controller, { control: control, name: "status", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekSelect, __assign({ labelId: "ui-br-agency.collections.general.status.select.label" }, field, { value: field.value || CollectionStatusEnum.UNKNOWN }), Object.values(CollectionStatusEnum).map(function (status) { return (React.createElement("option", { key: status, value: status }, formatMessage({
                            id: "ui-br-agency.collections.status.".concat(status),
                        }))); })));
                    } })),
            React.createElement(Col, { xs: 2 },
                React.createElement(Controller, { control: control, name: "endYear", render: function (_a) {
                        var _b, _c;
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { value: (_b = field.value) !== null && _b !== void 0 ? _b : "", labelId: "ui-br-agency.collections.general.endYear.field.label", error: (_c = errors.endYear) === null || _c === void 0 ? void 0 : _c.message })));
                    } })),
            React.createElement(Col, { xs: 2 },
                React.createElement(Controller, { control: control, name: "medium", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekSelect, __assign({ labelId: "ui-br-agency.collections.general.medium.select.label" }, field, { value: field.value || "" }),
                            React.createElement("option", { value: "" }, formatMessage({
                                id: "ui-br-agency.collections.medium.none",
                            })),
                            Object.values(CollectionMediumEnum).map(function (medium) { return (React.createElement("option", { key: medium, value: medium }, formatMessage({
                                id: "ui-br-agency.collections.medium.".concat(medium),
                            }))); })));
                    } })))));
};
